import React, { useState, useEffect } from "react";
import Logo from "assets/logo.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { CgMenuRightAlt } from "react-icons/cg";
import { getAppBaseUrl } from "constants/BaseUrlApp";

export default function TopBar() {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    let timeoutId;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Clear any existing timeout
      clearTimeout(timeoutId);

      // Hide when scrolling down, show when scrolling up
      if (currentScrollY > lastScrollY && currentScrollY > 10) {
        setIsVisible(false);
        setIsMobileMenuOpen(false);
      } else if (currentScrollY < lastScrollY) {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    const handleMouseMove = (e) => {
      // Show topbar when mouse moves to top 100px of screen
      if (e.clientY <= 100 && !isVisible) {
        setIsVisible(true);
      }
    };

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth >= 1000) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("mousemove", handleMouseMove, { passive: true });
    window.addEventListener("resize", handleResize, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeoutId);
    };
  }, [lastScrollY, isVisible]);

  const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
    // Close mobile menu after navigation
    setIsMobileMenuOpen(false);
  };

  const openAppLink = () => {
    window.open(getAppBaseUrl());
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: "65px",
          justifyContent: "space-between",
          padding: "0px 62px",
          background: "linear-gradient(180deg, #AFE0C1 0%, #FFFFFF 100%)",
          position: "fixed",
          top: 0,
          zIndex: 100,
          width: "calc(100vw - 124px)",
          transform: isVisible ? "translateY(0)" : "translateY(-100%)",
          opacity: isVisible ? 1 : 0,
          transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
        }}
      >
        <div
          onClick={() => {
            if (loc.pathname !== "/") nav("/");
            else scrollToElement("home");
          }}
          style={{ cursor: "pointer" }}
        >
          <img
            src={Logo}
            alt="Logo"
            width={"234px"}
            style={{ display: "block" }}
          />
        </div>

        {windowWidth >= 1000 ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "24px",
            }}
          >
            <div className="link" onClick={() => scrollToElement("features")}>
              Features
            </div>
            <div
              className="link"
              onClick={() => scrollToElement("how-it-works")}
            >
              How it works
            </div>
            <button
              className="primary-button secondary-button"
              style={{ cursor: "pointer" }}
              onClick={openAppLink}
            >
              LogIn
            </button>
            <button
              className="primary-button"
              style={{ cursor: "pointer" }}
              onClick={openAppLink}
            >
              Get started
            </button>
          </div>
        ) : (
          <div
            onClick={toggleMobileMenu}
            style={{
              cursor: "pointer",
            }}
          >
            {/* Hamburger menu icon */}
            <CgMenuRightAlt size={"30px"} />
          </div>
        )}
      </div>

      {/* Mobile menu */}
      {windowWidth < 1000 && (
        <div
          style={{
            position: "fixed",
            top: "65px",
            left: 0,
            width: "100%",
            background: "linear-gradient(180deg, #FFFFFF 0%, #AFE0C1 100%)",
            zIndex: 99,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: "20px",
            transform: isMobileMenuOpen ? "translateY(0)" : "translateY(-100%)",
            opacity: isMobileMenuOpen ? 1 : 0,
            transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          }}
        >
          <div
            className="link"
            onClick={() => scrollToElement("features")}
            style={{
              padding: "15px 0",
              width: "100%",
              textAlign: "center",
              fontSize: "18px",
            }}
          >
            Features
          </div>
          <div
            className="link"
            onClick={() => scrollToElement("how-it-works")}
            style={{
              padding: "15px 0",
              width: "100%",
              textAlign: "center",
              fontSize: "18px",
            }}
          >
            How it works
          </div>
          <button
            className="primary-button secondary-button"
            style={{
              cursor: "pointer",
              margin: "10px 0",
              width: "80%",
            }}
            onClick={openAppLink}
          >
            LogIn
          </button>
          <button
            className="primary-button"
            style={{
              cursor: "pointer",
              width: "80%",
            }}
            onClick={openAppLink}
          >
            Get started
          </button>
        </div>
      )}
    </>
  );
}
